import { SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate, useOutletContext } from 'react-router'

import { useNotifications } from 'app/application/application'
import { PublicRoutes } from 'app/application/types'
import { ArrowLeftIcon } from 'app/common/presentation/icons'

import { Button, Divider, Headline, Input } from 'components'

import accessStyles from '../AccessPage/AccessPage.module.scss'
import { validatePassword } from '../validatePassword'
import { UserAccessContext, isCreateWorkspaceInput } from './CreateAccess'
import styles from './CreateAccess.module.scss'

const SetupPasswordPage = () => {
  const { te } = useNotifications()
  const { t } = useTranslation('user')

  const navigate = useNavigate()

  const { error, formInput, handleCreateWorkspace, setError, setFormInput } =
    useOutletContext<UserAccessContext>()

  const isCreateWorkspace = isCreateWorkspaceInput(formInput)

  if (
    !formInput.email ||
    !formInput.firstName ||
    !formInput.inviteCode ||
    !formInput.lastName ||
    (isCreateWorkspaceInput(formInput) && !formInput.workspace)
  ) {
    return (
      <Navigate
        to={isCreateWorkspace ? PublicRoutes.CreateWorkspace : PublicRoutes.SignUp}
        replace
      />
    )
  }

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()

    const passwordError = validatePassword(formInput.password, formInput.passwordRepeat)
    if (passwordError) {
      setError(te(`password.${passwordError}`))
    } else {
      handleCreateWorkspace()
    }
  }

  return (
    <>
      <div>
        <Headline>{t('password.welcome')}</Headline>
        <div className={accessStyles.message}>{t('password.message')}</div>
      </div>
      <Divider />
      <form onSubmit={handleSubmit}>
        <Input
          autoComplete="new-password"
          autoFocus
          error={error ? ' ' : undefined}
          label={t('password.password')}
          mandatory
          onChange={(password) =>
            setFormInput((prev) => ({
              ...prev,
              password,
            }))
          }
          placeholder={t('password.placeholder.password')}
          type="password"
          value={formInput.password}
        />
        <Input
          autoComplete="new-password"
          error={error}
          label={t('password.passwordRepeat')}
          mandatory
          onChange={(passwordRepeat) =>
            setFormInput((prev) => ({
              ...prev,
              passwordRepeat,
            }))
          }
          placeholder={t('password.placeholder.password')}
          type="password"
          value={formInput.passwordRepeat}
        />
        <div className={styles.actions}>
          <Button
            leftIcon={<ArrowLeftIcon />}
            onClick={() => void navigate(-1)}
            variant="secondary"
          >
            {t('password.back')}
          </Button>
          <Button disabled={!formInput.password || !formInput.passwordRepeat} type="submit">
            {t('password.create')}
          </Button>
        </div>
      </form>
    </>
  )
}

export default SetupPasswordPage
